import React, { useEffect, useState } from "react";
import {
  Sparkles,
  Camera,
  Wand2,
  Download,
  Check,
  X,
  Clock,
  ShieldCheck,
  Star,
  ArrowRight,
  Zap,
  Heart,
  Flame,
  Instagram,
  TrendingUp,
  Volume2,
  VolumeX,
  Mail,
  Loader2,
  Menu,
} from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const CHECKOUT_URL = "https://dscaoaching.samcart.com/products/ai-twin";
const FREE_CREDITS_URL =
  "https://301d78a1-b050-4a85-acdf-4dd6cd0bb222.lovableproject.com/#create";
const GHL_WEBHOOK_URL =
  "https://services.leadconnectorhq.com/hooks/00rUS8kTZMl2DZiQRsgl/webhook-trigger/fa2d5f90-71f9-42d0-a682-229935930edc";
const BANNER_URL =
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/7v3qz2e4_IMG_6150.png";

const PROOF = {
  // 4.6K views / 12 followers dashboard (Mar 31 - Apr 29)
  before:
    "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/8ufn6bo9_IMG_6091.jpeg",
  // "This actually works?" viral reel (video)
  viral:
    "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/17yxx9ur_hf_20260429_052206_01f0b3fc-288c-49a9-ba0d-38ff793d8bc5.mp4",
  viralPoster:
    "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/yogzqk3h_IMG_6092.jpeg",
  // "Your views are way up" chart with +18720%
  chart:
    "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/vl2ye8jm_IMG_6175.jpeg",
  // 420.8K views / 10.5K followers dashboard (Apr 2 - May 1)
  after:
    "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/rsxnvhtj_IMG_6177.png",
};

const FOUNDER_IMG =
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/g02n42ka_Untitled%20design%20%284%29.png";

// AI portrait pool — mix of images and videos (.mp4). Auto-detected in renderer.
// NOTE: first 3 items must be images (used in hero grid slots 1-3)
const AI_GALLERY = [
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/qaiciqx2_FoxyAI_Image_4ee7947e-cff4-4476-83d6-acbe14356e4b.jpg",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/suhywen6_ChatGPT%20Image%20Jan%2018%2C%202026%2C%2008_12_05%20AM.png",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/8sivmtbn_FoxyAI_Image_1e80b313-5c49-4ea3-a5a1-2a7d17782a7b.jpg",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/hlkz6lbu_FoxyAI_Image_41c399a1-9cf4-4661-a66c-10b7c17d9899.jpg",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/ou95k85l_FoxyAI_Image_d6f3adb9-02ac-4113-b07c-6e87d0a7b0d4.jpg",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/k6l7mrc3_820F5226-7E62-49AD-B3E3-92DE5E4EF715.png",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/4k3skad9_openart-image_kgAAzHW__1768754641648_raw.png",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/futnivrp_openart-image_AAL98HqW_1775845257114_raw.jpg",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/ey708sl9_openart-image_J15LyFVR_1775845443313_raw.jpg",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/4uv4pg9o_openart-image_yPdrjg5g_1775845104995_raw.jpg",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/q8n5m469_2e9d1820-3b27-4bf4-a814-99ef42f4b399-md.jpg",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/f103c6pq_Mickey%20dog.jpg",
];

const isVideo = (url) => /\.mp4(\?|$)/i.test(url);

// Fire Meta Pixel InitiateCheckout on every CTA click
const trackCheckout = () => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "InitiateCheckout", {
      value: 27,
      currency: "USD",
      content_name: "Studio-quality content · 3 photos + 1 reel",
      content_ids: ["ai-twin-27"],
    });
  }
};

const MediaTile = ({ src, className = "", testid }) =>
  isVideo(src) ? (
    <video
      src={src}
      autoPlay
      muted
      loop
      playsInline
      className={className}
      data-testid={testid}
    />
  ) : (
    <img src={src} alt="" className={className} data-testid={testid} />
  );

const TRANSFORMATIONS = [
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/0dsa1kwi_AI%20FOR%20BOSS%20BABES%20%281%29%20copy%202.png",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/wbpguuzw_AI%20FOR%20BOSS%20BABES%20%281%29.png",
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/5p37l1xs_AI%20FOR%20BOSS%20BABES%20%281%29%20copy.png",
];

function useCountdown(initialSeconds) {
  const [s, setS] = useState(initialSeconds);
  useEffect(() => {
    if (s <= 0) return;
    const id = setInterval(() => setS((p) => Math.max(0, p - 1)), 1000);
    return () => clearInterval(id);
  }, [s]);
  return {
    h: String(Math.floor(s / 3600)).padStart(2, "0"),
    m: String(Math.floor((s % 3600) / 60)).padStart(2, "0"),
    s: String(s % 60).padStart(2, "0"),
  };
}

const PillCTA = ({ label = "Claim my studio content · $27", testid, variant = "coral" }) => (
  <a
    href={CHECKOUT_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={trackCheckout}
    data-testid={testid}
    className={variant === "coral" ? "btn-coral" : "btn-cream"}
  >
    <Sparkles className="w-4 h-4" />
    {label}
    <ArrowRight className="w-4 h-4" />
  </a>
);

// Hero reel — cycles through 4 clips to show AI Twin range across niches
// Kept small for mobile bandwidth. Add more only if data-testing warrants it.
const HERO_CLIPS = [
  "https://customer-assets.emergentagent.com/job_digital-you-creator/artifacts/m5z73cyb_dress%20courtney.mp4",
  "https://customer-assets-wrfwihn1.emergentagent.net/job_digital-you-creator/artifacts/12ro1voj_Wellness%20day.mp4",
  "https://customer-assets-wrfwihn1.emergentagent.net/job_digital-you-creator/artifacts/qi8gz42m_City%20party.mp4",
  "https://customer-assets-wrfwihn1.emergentagent.net/job_digital-you-creator/artifacts/wixeuvij_HU%20Recipe.mp4",
];

// ----- HERO SOUND VIDEO — tap to unmute + auto-cycle through clips -----
const HeroSoundVideo = () => {
  const videoRef = React.useRef(null);
  const [muted, setMuted] = useState(true);
  const [clipIndex, setClipIndex] = useState(0);

  const toggleSound = (e) => {
    e.stopPropagation();
    const v = videoRef.current;
    if (!v) return;
    const next = !muted;
    v.muted = next;
    v.volume = next ? 0 : 1;
    if (!next) v.play().catch(() => {});
    setMuted(next);
  };

  const nextClip = () => {
    setClipIndex((i) => (i + 1) % HERO_CLIPS.length);
  };

  return (
    <div
      className="relative bg-black border-2 border-[var(--ink)] rounded-[40px] overflow-hidden shadow-[10px_10px_0_var(--ink)] rotate-1 cursor-pointer"
      onClick={toggleSound}
      data-testid="hero-sound-video-wrapper"
    >
      <video
        ref={videoRef}
        key={clipIndex}
        src={HERO_CLIPS[clipIndex]}
        autoPlay
        muted={muted}
        playsInline
        onEnded={nextClip}
        data-allow-sound="true"
        className="w-full aspect-[9/16] object-cover"
        data-testid="hero-main-video"
      />

      {/* LIVE pill */}
      <div className="absolute top-4 left-4 inline-flex items-center gap-2 bg-black/70 backdrop-blur border border-white/20 rounded-full px-3 py-1 pointer-events-none">
        <span className="w-2 h-2 bg-red-500 pulse-dot rounded-full" />
        <span className="text-[10px] tracking-[0.28em] uppercase font-bold text-white">
          100% AI
        </span>
      </div>

      {/* Unmute button */}
      <button
        type="button"
        onClick={toggleSound}
        aria-label={muted ? "Unmute video" : "Mute video"}
        data-testid="hero-video-sound-toggle"
        className="absolute top-4 right-4 w-11 h-11 rounded-full bg-black/70 backdrop-blur border border-white/30 flex items-center justify-center hover:bg-[var(--burgundy)] transition-colors"
      >
        {muted ? (
          <VolumeX className="w-5 h-5 text-white" />
        ) : (
          <Volume2 className="w-5 h-5 text-white" />
        )}
      </button>

      {/* Clip progress dots */}
      <div
        className="absolute bottom-16 left-1/2 -translate-x-1/2 flex items-center gap-1.5 bg-black/50 backdrop-blur rounded-full px-3 py-1.5 pointer-events-none"
        data-testid="hero-clip-progress"
      >
        {HERO_CLIPS.map((_, i) => (
          <span
            key={i}
            className={`h-1.5 rounded-full transition-all ${
              i === clipIndex ? "w-6 bg-white" : "w-1.5 bg-white/40"
            }`}
          />
        ))}
      </div>

      {/* "Tap for sound" prompt — fades out on first interaction */}
      {muted && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white text-[var(--ink)] px-4 py-2 rounded-full border-2 border-[var(--ink)] shadow-[3px_3px_0_var(--ink)] flex items-center gap-2 text-sm font-bold whitespace-nowrap pointer-events-none animate-pulse">
          <Volume2 className="w-4 h-4 text-[var(--burgundy)]" />
          tap for sound
        </div>
      )}
    </div>
  );
};

// ----- HEADER -----
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#fff4ec]/85 backdrop-blur-md border-b-2 border-[var(--ink)]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2" data-testid="brand-logo">
          <div className="w-9 h-9 bg-[var(--burgundy)] border-2 border-[var(--ink)] rounded-full flex items-center justify-center -rotate-6">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="font-display text-xl">
            <span className="font-script text-3xl text-[var(--burgundy)] align-middle mr-2">
              ai
            </span>
            for boss babes
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-[var(--ink)]/70">
          <a href="#how" className="hover:text-[var(--coral)]" data-testid="nav-how">How it works</a>
          <a href="#offer" className="hover:text-[var(--coral)]" data-testid="nav-offer">The Offer</a>
          <Link to="/classes" className="hover:text-[var(--coral)]" data-testid="nav-classes">Classes</Link>
          <a href="#faq" className="hover:text-[var(--coral)]" data-testid="nav-faq">FAQ</a>
        </nav>

        <div className="hidden md:block">
          <PillCTA label="Get $27 deal" testid="header-cta" />
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-white border-2 border-[var(--ink)] shadow-[3px_3px_0_var(--ink)] hover:bg-[var(--lemon)] transition-colors"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          data-testid="mobile-menu-toggle"
        >
          {menuOpen ? (
            <X className="w-5 h-5 text-[var(--ink)]" strokeWidth={2.5} />
          ) : (
            <Menu className="w-5 h-5 text-[var(--ink)]" strokeWidth={2.5} />
          )}
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div
          className="md:hidden border-t-2 border-[var(--ink)] bg-[#fff4ec] shadow-lg"
          data-testid="mobile-menu-drawer"
        >
          <nav className="flex flex-col divide-y divide-[var(--ink)]/10">
            <a href="#how" onClick={close} className="px-6 py-4 font-semibold text-[var(--ink)] hover:bg-[var(--lemon)]" data-testid="mobile-nav-how">How it works</a>
            <a href="#offer" onClick={close} className="px-6 py-4 font-semibold text-[var(--ink)] hover:bg-[var(--lemon)]" data-testid="mobile-nav-offer">The Offer</a>
            <Link to="/classes" onClick={close} className="px-6 py-4 font-semibold text-[var(--ink)] hover:bg-[var(--lemon)]" data-testid="mobile-nav-classes">Classes</Link>
            <a href="#faq" onClick={close} className="px-6 py-4 font-semibold text-[var(--ink)] hover:bg-[var(--lemon)]" data-testid="mobile-nav-faq">FAQ</a>
            <a
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => { trackCheckout(); close(); }}
              className="px-6 py-4 font-bold text-white bg-[var(--burgundy)] hover:bg-[var(--burgundy-hover)] flex items-center justify-between"
              data-testid="mobile-nav-cta"
            >
              Get $27 deal
              <ArrowRight className="w-4 h-4" />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

// ----- HERO -----
const Hero = () => {
  const { h, m, s } = useCountdown(11 * 3600 + 47 * 60);
  return (
    <section
      data-testid="hero-section"
      className="relative pt-12 md:pt-16 pb-20 md:pb-24 overflow-hidden"
    >
      <div className="blob bg-[var(--coral)] w-96 h-96 -top-32 -left-20" />
      <div className="blob bg-[var(--peach)] w-80 h-80 top-40 right-0" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-10 items-center">
        {/* Left */}
        <div className="lg:col-span-7 fade-up">
          <span
            className="tag-pill mb-5"
            data-testid="hero-badge"
          >
            <span className="w-2 h-2 bg-[var(--coral)] pulse-dot rounded-full" />
            founding price — limited spots
          </span>

          <p
            className="text-base md:text-lg font-semibold text-[var(--burgundy)] mb-4 italic"
            data-testid="hero-hook"
          >
            Still posting random selfies and wondering why nobody buys?
          </p>

          <h1 className="font-display text-[12vw] md:text-[7.5vw] lg:text-[6rem] mb-7">
            Your <span className="highlight-yellow">studio-quality</span> content.
            <br />
            Your whole feed.
            <br />
            <span className="highlight-coral">In minutes.</span>
          </h1>

          <div
            className="bg-white border-2 border-[var(--ink)] rounded-2xl p-5 md:p-6 mb-8 shadow-[5px_5px_0_var(--ink)] max-w-md"
            data-testid="hero-deliverables"
          >
            <div className="text-[10px] tracking-[0.28em] uppercase font-bold text-[var(--burgundy)] mb-3">
              For $27 You Receive
            </div>
            <ul className="space-y-2 text-[var(--ink)] text-sm md:text-base font-medium">
              <li className="flex items-start gap-2">
                <Check className="w-4 h-4 text-[var(--burgundy)] mt-0.5 flex-shrink-0" strokeWidth={3} />
                3 AI luxury photos of yourself
              </li>
              <li className="flex items-start gap-2">
                <Check className="w-4 h-4 text-[var(--burgundy)] mt-0.5 flex-shrink-0" strokeWidth={3} />
                1 scroll-stopping AI reel
              </li>
              <li className="flex items-start gap-2">
                <Check className="w-4 h-4 text-[var(--burgundy)] mt-0.5 flex-shrink-0" strokeWidth={3} />
                Instant access to your AI studio
              </li>
              <li className="flex items-start gap-2">
                <Check className="w-4 h-4 text-[var(--burgundy)] mt-0.5 flex-shrink-0" strokeWidth={3} />
                Commercial usage rights
              </li>
              <li className="flex items-start gap-2">
                <Check className="w-4 h-4 text-[var(--burgundy)] mt-0.5 flex-shrink-0" strokeWidth={3} />
                Ready-to-post social content
              </li>
            </ul>
          </div>

          <div className="flex flex-wrap items-center gap-4 mb-6">
            <PillCTA testid="hero-primary-cta" label="YES — make me unmissable · $27" />
            <a
              href="#gallery"
              data-testid="hero-secondary-cta"
              className="text-[var(--ink)] underline underline-offset-4 decoration-2 font-semibold hover:text-[var(--coral)]"
            >
              See the goods ↓
            </a>
          </div>

          {/* Objection crushers */}
          <div
            className="grid grid-cols-2 gap-x-5 gap-y-2 mb-8 max-w-md"
            data-testid="objection-crushers"
          >
            {[
              "No modeling experience needed",
              "iPhone selfies work",
              "You still look like you",
              "No filming required",
            ].map((t, i) => (
              <div
                key={i}
                className="flex items-start gap-2 text-[var(--ink)]/85 text-sm font-medium"
              >
                <Check
                  className="w-4 h-4 text-[var(--burgundy)] mt-0.5 flex-shrink-0"
                  strokeWidth={3}
                />
                {t}
              </div>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-[var(--ink)]/70">
            <div className="flex items-center gap-1.5 text-[var(--burgundy)]">
              <Star className="w-4 h-4 fill-current" />
              <b className="text-[var(--ink)]">Top-rated</b>
            </div>
            <span>· <b>instant access</b></span>
            <span className="hidden sm:inline">· built by <b>Daniella</b></span>
          </div>
        </div>

        {/* Right — Big phone video taking center stage */}
        <div className="lg:col-span-5 relative fade-up delay-200">
          <div className="relative max-w-[420px] mx-auto">
            {/* coral blob behind */}
            <div className="absolute -inset-4 bg-[var(--coral)] rounded-[40px] -rotate-2"></div>

            {/* big phone video with tap-to-unmute */}
            <HeroSoundVideo />

            {/* countdown sticker */}
            <div
              className="absolute -top-6 -right-4 bg-[var(--lemon)] border-2 border-[var(--ink)] rounded-2xl px-4 py-3 wiggle shadow-[4px_4px_0_var(--ink)] text-center"
              data-testid="hero-countdown"
            >
              <div className="text-[10px] font-bold tracking-widest">EXPIRES IN</div>
              <div className="font-display text-2xl text-[var(--ink)]">
                {h}:{m}:{s}
              </div>
            </div>

            {/* bottom badge */}
            <div className="absolute -bottom-5 left-6 right-6 bg-white border-2 border-[var(--ink)] rounded-full px-4 py-2 flex items-center justify-center gap-2 shadow-[3px_3px_0_var(--ink)]">
              <Sparkles className="w-4 h-4 text-[var(--burgundy)]" />
              <span className="text-sm font-bold text-[var(--ink)]">
                For $27 · this could be{" "}
                <span className="italic text-[var(--burgundy)]">you</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// ----- PAIN -----
const PainPoint = () => (
  <section className="relative py-24 md:py-32 section-cream" data-testid="pain-section">
    <div className="max-w-5xl mx-auto px-5 md:px-8 text-center">
      <span className="tag-pill mb-6">The truth · don&apos;t take it personal</span>
      <h2 className="font-display text-5xl md:text-7xl mb-8 leading-[0.95]">
        Your{" "}
        <span className="scribble-strike text-[var(--ink)] relative z-10">selfies</span>{" "}
        are why
        <br />
        clients keep scrolling.
      </h2>
      <p className="text-lg md:text-xl text-[var(--ink)]/70 max-w-2xl mx-auto mb-14">
        It&apos;s not your offer. It&apos;s not the algorithm. It&apos;s the way you&apos;re
        showing up — and you already know it.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {[
          { icon: "📸", t: "Selfies in your car between meetings" },
          { icon: "💸", t: "$2,000 photoshoots you can&apos;t justify" },
          { icon: "😩", t: "Hating every photo by post day" },
          { icon: "👀", t: "Watching her premium feed instead" },
        ].map((p, i) => (
          <div
            key={i}
            className="sticker-card p-6 text-left"
            style={{ transform: `rotate(${(i - 1.5) * 1.2}deg)` }}
            data-testid={`pain-card-${i}`}
          >
            <div className="text-4xl mb-3">{p.icon}</div>
            <p
              className="font-semibold text-lg leading-snug"
              dangerouslySetInnerHTML={{ __html: p.t }}
            />
          </div>
        ))}
      </div>

      <p className="font-display text-3xl md:text-5xl mt-16">
        It&apos;s not a business problem.
        <br />
        It&apos;s a <span className="text-[var(--coral)] italic">visibility</span> problem.
      </p>
    </div>
  </section>
);

// ----- HOW IT WORKS -----
const steps = [
  { n: "01", icon: Zap, title: "Pay $27 → unlock your studio", body: "No queue, no waiting. You're inside the second you pay." },
  { n: "02", icon: Camera, title: "Upload one selfie", body: "From your phone. No studio. No prep." },
  { n: "03", icon: Download, title: "Generate & download", body: "Pick a reel template. Get your AI twin photos + reel in minutes. Download and post." },
];

const Solution = () => (
  <section
    id="how"
    data-testid="solution-section"
    className="relative py-24 md:py-32 section-peach overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="text-center mb-14">
        <span className="tag-pill mb-5">how it works</span>
        <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
          A whole feed in
          <br />
          <span className="text-[var(--coral)] italic">three taps.</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        {steps.map(({ n, icon: Icon, title, body }, i) => (
          <div
            key={i}
            className="sticker-card p-8 md:p-10 relative"
            style={{ transform: `rotate(${(i - 1) * 1.5}deg)` }}
            data-testid={`solution-step-${i + 1}`}
          >
            <div className="absolute -top-5 -left-3 bg-[var(--ink)] text-white font-display text-2xl w-12 h-12 rounded-full flex items-center justify-center border-2 border-[var(--ink)]">
              {n}
            </div>
            <div className="w-14 h-14 bg-[var(--lemon)] border-2 border-[var(--ink)] rounded-2xl flex items-center justify-center mb-6 mt-3">
              <Icon className="w-7 h-7 text-[var(--ink)]" />
            </div>
            <h3 className="font-display text-3xl mb-3">{title}</h3>
            <p className="text-[var(--ink)]/70 text-lg leading-snug">{body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ----- OFFER -----

// Email-gate modal — fires when user clicks "Try 3 free credits".
// Captures email → posts to GHL webhook → redirects to free credits app.
const FreeCreditsModal = ({ open, onClose }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [error, setError] = useState("");

  // Reset when reopened
  useEffect(() => {
    if (open) {
      setEmail("");
      setStatus("idle");
      setError("");
    }
  }, [open]);

  // Auto-redirect on success
  useEffect(() => {
    if (status !== "success") return;
    const t = setTimeout(() => {
      window.open(FREE_CREDITS_URL, "_blank", "noopener,noreferrer");
      onClose();
    }, 1800);
    return () => clearTimeout(t);
  }, [status, onClose]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const clean = email.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clean)) {
      setError("Please enter a valid email");
      return;
    }
    setError("");
    setStatus("submitting");
    try {
      await fetch(GHL_WEBHOOK_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: clean,
          source: "boss-babes-ai-landing",
          tag: "free-trial-skeptic",
          submitted_at: new Date().toISOString(),
        }),
      });
      // no-cors → we can't read the response, so we optimistically move to success
      if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq("track", "Lead", {
          content_name: "Free credits trial",
          value: 0,
          currency: "USD",
        });
      }
      setStatus("success");
    } catch (err) {
      setStatus("error");
      setError("Something went wrong. Try again in a sec.");
    }
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[var(--ink)]/70 backdrop-blur-sm"
      onClick={onClose}
      data-testid="free-credits-modal-backdrop"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md bg-[var(--cream)] border-2 border-[var(--ink)] rounded-[28px] shadow-[10px_10px_0_var(--ink)] p-7 md:p-8"
        data-testid="free-credits-modal"
      >
        <button
          onClick={onClose}
          aria-label="Close"
          data-testid="free-credits-modal-close"
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white border-2 border-[var(--ink)] flex items-center justify-center hover:bg-[var(--lemon)] transition-colors"
        >
          <X className="w-4 h-4 text-[var(--ink)]" strokeWidth={3} />
        </button>

        {status === "success" ? (
          <div className="text-center py-4">
            <div className="w-14 h-14 mx-auto mb-4 bg-[var(--lemon)] border-2 border-[var(--ink)] rounded-full flex items-center justify-center">
              <Check className="w-7 h-7 text-[var(--burgundy)]" strokeWidth={3} />
            </div>
            <h3 className="font-display text-3xl text-[var(--ink)] leading-tight mb-2">
              You&apos;re in, babe 💕
            </h3>
            <p className="text-[var(--ink)]/70 text-base mb-4">
              Check your inbox — sending you to your credits now...
            </p>
            <div className="flex items-center justify-center gap-2 text-[var(--burgundy)] text-sm font-semibold">
              <Loader2 className="w-4 h-4 animate-spin" />
              Redirecting...
            </div>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-9 h-9 bg-[var(--burgundy)] border-2 border-[var(--ink)] rounded-full flex items-center justify-center">
                <Mail className="w-4 h-4 text-white" strokeWidth={2.5} />
              </div>
              <span className="text-[10px] tracking-[0.28em] uppercase font-bold text-[var(--burgundy)]">
                Free · No card required
              </span>
            </div>
            <h3 className="font-display text-3xl md:text-4xl text-[var(--ink)] leading-[1.05] mt-2 mb-2">
              Get your <span className="italic text-[var(--burgundy)]">3 free credits</span> 💕
            </h3>
            <p className="text-[var(--ink)]/70 text-base mb-5 leading-relaxed">
              Drop your email and we&apos;ll send them straight to your inbox — plus early access when we open new drops.
            </p>

            <form onSubmit={onSubmit} className="space-y-3" data-testid="free-credits-form">
              <input
                type="email"
                inputMode="email"
                autoComplete="email"
                placeholder="you@yourbrand.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={status === "submitting"}
                data-testid="free-credits-email-input"
                className="w-full px-4 py-3.5 rounded-2xl border-2 border-[var(--ink)] bg-white text-[var(--ink)] font-medium placeholder:text-[var(--ink)]/40 focus:outline-none focus:ring-4 focus:ring-[var(--coral)]/30 shadow-[3px_3px_0_var(--ink)]"
              />
              {error && (
                <p className="text-[var(--burgundy)] text-sm font-semibold" data-testid="free-credits-error">
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={status === "submitting"}
                data-testid="free-credits-submit"
                className="w-full py-3.5 rounded-full bg-[var(--burgundy)] hover:bg-[var(--burgundy-hover)] text-white font-bold border-2 border-[var(--ink)] shadow-[4px_4px_0_var(--ink)] hover:shadow-[6px_6px_0_var(--ink)] hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {status === "submitting" ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Sending your credits...
                  </>
                ) : (
                  <>
                    Send me my 3 credits
                    <ArrowRight className="w-4 h-4" />
                  </>
                )}
              </button>
              <p className="text-[var(--ink)]/50 text-xs text-center pt-1">
                No spam, ever. Unsubscribe anytime.
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

const Offer = () => {
  const includes = [
    { l: "3 scroll-stopping AI photos (4K)", v: "$210" },
    { l: "1 custom AI reel (7–10s, scroll-coded)", v: "$197" },
    { l: "Magazine-grade retouching", v: "$60" },
    { l: "Full commercial rights", v: "Priceless" },
    { l: "Instant studio access", v: "$80" },
  ];
  const [showFreeCredits, setShowFreeCredits] = useState(false);
  return (
    <section
      id="offer"
      data-testid="offer-section"
      className="relative py-24 md:py-32 section-ink overflow-hidden"
    >
      <div className="blob bg-[var(--coral)] w-[500px] h-[500px] -top-40 -left-20" />
      <div className="blob bg-[var(--peach)] w-[400px] h-[400px] -bottom-32 -right-20 opacity-40" />

      <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
          <span className="tag-pill mb-6 bg-[var(--lemon)] text-[var(--ink)]">
            FOUNDING OFFER · $27
          </span>
        <h2 className="font-display text-5xl md:text-7xl text-white mb-6">
          Founding pricing for{" "}
          <span className="text-[var(--lemon)] italic">first-mover boss babes.</span>
        </h2>
        <p className="text-white/70 text-lg max-w-xl mx-auto mb-12">
          We&apos;re onboarding our first wave of women at a one-time founder rate. When this round closes, the price moves to its regular tier.
        </p>

        <div className="bg-white border-2 border-[var(--ink)] rounded-[28px] shadow-[10px_10px_0_var(--coral)] p-8 md:p-10 text-left">
          <ul className="space-y-4 mb-8">
            {includes.map((item, i) => (
              <li
                key={i}
                className="flex items-center justify-between gap-4 pb-4 border-b-2 border-dashed border-[var(--ink)]/15 last:border-0 last:pb-0"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-[var(--lemon)] border-2 border-[var(--ink)] rounded-full flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-[var(--ink)]" strokeWidth={3} />
                  </div>
                  <span className="text-[var(--ink)] text-base md:text-lg font-semibold">{item.l}</span>
                </div>
                <span className="text-[var(--ink)]/60 text-sm md:text-base font-bold whitespace-nowrap">
                  {item.v}
                </span>
              </li>
            ))}
          </ul>

          <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-5 border-t-4 border-[var(--coral)]">
            <div>
              <div className="text-[var(--ink)]/60 text-xs uppercase tracking-widest font-bold mb-1">
                Real value
              </div>
              <div className="flex items-end gap-3">
                <span className="text-[var(--ink)]/40 text-3xl line-through font-display">
                  $47
                </span>
                <span className="font-display text-6xl md:text-7xl text-[var(--burgundy)]">$27</span>
              </div>
            </div>
            <PillCTA testid="offer-cta" label="I want this · $27" />
          </div>
        </div>

        <div className="mt-6 text-center">
          <button
            type="button"
            onClick={() => setShowFreeCredits(true)}
            data-testid="try-free-credits-link"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm font-medium underline underline-offset-4 decoration-white/30 hover:decoration-[var(--lemon)] transition-colors bg-transparent border-0 cursor-pointer p-0"
          >
            Not ready? Try 3 free credits
            <span aria-hidden="true">→</span>
          </button>
        </div>

        <div className="mt-6 flex flex-col items-center gap-2 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-4 h-4 text-[var(--lemon)]" />
            <span className="font-semibold text-white">Our Founder&apos;s Promise</span>
          </div>
          <p className="text-white/65 text-sm max-w-md text-center leading-relaxed">
            Your own AI studio, ready the second you pay. Generate as many takes as you want until you get one you&apos;re proud to post.
          </p>
        </div>
      </div>
      <FreeCreditsModal open={showFreeCredits} onClose={() => setShowFreeCredits(false)} />
    </section>
  );
};

// ----- GALLERY -----
const Gallery = () => (
  <section
    id="gallery"
    data-testid="gallery-section"
    className="relative py-24 md:py-32 section-cream overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-5 md:px-8 mb-12">
      <div className="flex items-end justify-between flex-wrap gap-6">
        <div>
          <span className="tag-pill mb-5">real results</span>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
            These aren&apos;t models.
            <br />
            They&apos;re <span className="text-[var(--coral)] italic">our clients.</span>
          </h2>
        </div>
        <p className="text-[var(--ink)]/70 max-w-sm text-lg">
          Coaches, realtors, founders — all looking like they hired Vogue.
        </p>
      </div>
    </div>

    {/* dual marquees */}
    <div className="space-y-4">
      <div className="overflow-hidden">
        <div className="marquee-row">
          {[...AI_GALLERY, ...AI_GALLERY].map((src, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-48 h-64 md:w-56 md:h-72 rounded-2xl overflow-hidden border-2 border-[var(--ink)] shadow-[5px_5px_0_var(--ink)] bg-black"
              data-testid={`gallery-row1-${i}`}
            >
              <MediaTile src={src} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
      <div className="overflow-hidden">
        <div className="marquee-row-rev">
          {[...AI_GALLERY.slice().reverse(), ...AI_GALLERY.slice().reverse()].map((src, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-48 h-64 md:w-56 md:h-72 rounded-2xl overflow-hidden border-2 border-[var(--ink)] shadow-[5px_5px_0_var(--ink)] bg-black"
              data-testid={`gallery-row2-${i}`}
            >
              <MediaTile src={src} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

// ----- RECEIPTS / PROOF -----
const receipts = [
  {
    src: PROOF.before,
    tag: "Before",
    caption: "4.6K views · 12 new followers",
    rotate: -2,
  },
  {
    src: PROOF.viral,
    poster: PROOF.viralPoster,
    video: true,
    tag: "The Post",
    caption: "&ldquo;This actually works?&rdquo;",
    rotate: 1.5,
  },
  {
    src: PROOF.chart,
    tag: "The Explosion",
    caption: "+18,720% views month-over-month",
    rotate: -1,
  },
  {
    src: PROOF.after,
    tag: "After",
    caption: "420.8K views · 10.5K new followers · 8K interactions",
    rotate: 2,
    highlight: true,
  },
];

const Receipts = () => (
  <section
    className="relative py-24 md:py-32 section-cream overflow-hidden"
    data-testid="receipts-section"
  >
    <div className="blob bg-[var(--hot-pink)] w-[500px] h-[500px] top-20 -left-40" />

    <div className="relative max-w-7xl mx-auto px-5 md:px-8 mb-14 text-center">
      <span className="tag-pill mb-5">the receipts · real screenshots</span>
      <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
        From 12 followers
        <br />
        to <span className="italic text-[var(--burgundy)]">420K views</span>.
      </h2>
      <p className="text-[var(--ink)]/70 text-lg max-w-2xl mx-auto mt-6">
        Not a testimonial. Not a case study. Just screenshots from one creator&apos;s
        phone — before &amp; after her studio-quality content drop.
      </p>
    </div>

    <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-7">
      {receipts.map((r, i) => (
        <div
          key={i}
          className="sticker-card overflow-hidden"
          style={{
            transform: `rotate(${r.rotate}deg)`,
            background: r.highlight ? "var(--burgundy)" : "#fff",
          }}
          data-testid={`receipt-${i}`}
        >
          <div className="p-3">
            {r.video ? (
              <video
                src={r.src}
                poster={r.poster}
                autoPlay
                muted
                loop
                playsInline
                className="w-full aspect-[9/16] object-cover rounded-xl border-2 border-[var(--ink)] bg-black"
              />
            ) : (
              <img
                src={r.src}
                alt={r.tag}
                className="w-full aspect-[9/16] object-cover rounded-xl border-2 border-[var(--ink)] bg-white"
              />
            )}
          </div>
          <div className={`px-4 pb-5 ${r.highlight ? "text-white" : "text-[var(--ink)]"}`}>
            <div
              className={`text-[10px] tracking-[0.28em] uppercase font-bold mb-1 ${
                r.highlight ? "text-[var(--lemon)]" : "text-[var(--burgundy)]"
              }`}
            >
              {r.tag}
            </div>
            <p
              className="font-display text-lg md:text-xl leading-tight"
              dangerouslySetInnerHTML={{ __html: r.caption }}
            />
          </div>
        </div>
      ))}
    </div>

    <p className="relative text-center font-display text-3xl md:text-4xl mt-16 px-5">
      The algorithm didn&apos;t change.
      <br />
      <span className="italic text-[var(--burgundy)]">her content did.</span>
    </p>
  </section>
);

// ----- TRANSFORMATIONS -----
// ----- CLIENT WINS (real dashboards from accounts we run) -----
const CLIENT_WINS = [
  {
    niche: "Fitness Trainer",
    period: "Jul 3 → Aug 1",
    views: "705.3K",
    followers: "+531",
    thumb:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_digital-you-creator/artifacts/7wq8xiv7_Posturetrain.webp",
    highlight: "flagship result",
  },
  {
    niche: "Real Estate — SoCal",
    period: "Jul 3 → Aug 1",
    views: "82.2K",
    followers: "+143",
    thumb:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_digital-you-creator/artifacts/q6ca5qqz_Real%20estate%20agent%20in%20So%20cal%20.webp",
    highlight: "consistent growth",
  },
  {
    niche: "Coach / Creator",
    period: "Jul 3 → Aug 1",
    views: "76.3K",
    followers: "+175",
    thumb:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_digital-you-creator/artifacts/x6wcv2sz_IMG_1722.webp",
    highlight: "2.7K interactions",
  },
  {
    niche: "Wellness Creator",
    period: "Jul 1 → Jul 30",
    views: "475.4K",
    followers: "+302",
    thumb:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_digital-you-creator/artifacts/f1x3q18q_IMG_1639.webp",
    highlight: "42% more plays on 1 reel",
  },
];

const ClientWins = () => (
  <section
    id="client-wins"
    data-testid="client-wins-section"
    className="relative py-24 md:py-32 section-cream overflow-hidden"
  >
    <div className="blob bg-[var(--coral)] w-[400px] h-[400px] -top-20 -left-20 opacity-30" />
    <div className="blob bg-[var(--lemon)] w-[350px] h-[350px] -bottom-16 -right-10 opacity-50" />

    <div className="relative max-w-6xl mx-auto px-5 md:px-8">
      <div className="text-center mb-14">
        <span className="tag-pill mb-5 bg-[var(--burgundy)] text-white">
          real dashboards · real clients
        </span>
        <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
          These aren&apos;t our screenshots.
          <br />
          <span className="italic text-[var(--burgundy)]">They&apos;re our clients&apos;.</span>
        </h2>
        <p className="text-[var(--ink)]/70 text-lg max-w-2xl mx-auto mt-6">
          Instagram Professional Dashboards from real accounts we run. Names redacted
          for privacy — numbers untouched.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-7">
        {CLIENT_WINS.map((w, i) => (
          <div
            key={w.niche}
            data-testid={`client-win-${i}`}
            className="bg-white border-2 border-[var(--ink)] rounded-[22px] shadow-[6px_6px_0_var(--ink)] overflow-hidden flex flex-col"
            style={{ transform: `rotate(${(i - 1.5) * 0.9}deg)` }}
          >
            <div className="bg-[var(--lemon)] border-b-2 border-[var(--ink)] px-4 py-3 flex items-center justify-between">
              <span className="text-[10px] tracking-[0.2em] uppercase font-bold text-[var(--ink)]">
                {w.niche}
              </span>
              <span className="text-[10px] font-semibold text-[var(--ink)]/60">
                {w.period}
              </span>
            </div>

            <div className="p-2 bg-[var(--cream)]">
              <img
                src={w.thumb}
                alt={`${w.niche} Instagram dashboard — ${w.views} views`}
                loading="lazy"
                className="w-full aspect-[9/16] object-cover rounded-lg border-2 border-[var(--ink)] bg-white"
              />
            </div>

            <div className="px-5 pt-4 pb-5 border-t-2 border-dashed border-[var(--ink)]/15">
              <div className="flex items-baseline justify-between mb-1">
                <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--ink)]/50">
                  Views
                </span>
                <span className="font-display text-3xl md:text-4xl text-[var(--burgundy)] leading-none">
                  {w.views}
                </span>
              </div>
              <div className="flex items-baseline justify-between mt-3 pt-3 border-t border-[var(--ink)]/10">
                <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--ink)]/50">
                  New followers
                </span>
                <span className="font-bold text-xl text-[var(--ink)]">
                  {w.followers}
                </span>
              </div>
              <div className="mt-4 inline-flex items-center gap-1.5 bg-[var(--lemon)] border border-[var(--ink)]/20 rounded-full px-3 py-1">
                <TrendingUp className="w-3 h-3 text-[var(--burgundy)]" />
                <span className="text-[11px] font-bold text-[var(--ink)]">
                  {w.highlight}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <p className="text-center text-[var(--ink)]/60 text-sm mt-10 max-w-xl mx-auto">
        Different niches. Same system. Every screenshot is a real IG Professional
        Dashboard from an account we manage.
      </p>
    </div>
  </section>
);

// ----- TRANSFORMATIONS -----
const Transformations = () => (
  <section
    className="relative py-24 md:py-32 section-peach overflow-hidden"
    data-testid="transformations-section"
  >
    <div className="relative max-w-7xl mx-auto px-5 md:px-8 mb-14 text-center">
      <span className="tag-pill mb-5">real women · real glow-ups</span>
      <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
        Same woman.
        <br />
        <span className="italic text-[var(--burgundy)]">
          New energy online.
        </span>
      </h2>
      <p className="text-[var(--ink)]/75 text-lg max-w-2xl mx-auto mt-6">
        No filters. No edits. No hair extensions. Just a handful of selfies →
        a brand they finally feel proud to post.
      </p>
    </div>

    <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-3 gap-5 lg:gap-7">
      {TRANSFORMATIONS.map((src, i) => (
        <div
          key={i}
          className="sticker-card p-3"
          style={{ transform: `rotate(${(i - 1) * 1.3}deg)` }}
          data-testid={`transformation-${i}`}
        >
          <img
            src={src}
            alt={`AI for Boss Babes transformation ${i + 1}`}
            className="w-full aspect-square object-cover rounded-xl border-2 border-[var(--ink)]"
          />
        </div>
      ))}
    </div>

    <div className="relative text-center mt-14">
      <a
        href={CHECKOUT_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackCheckout}
        className="btn-coral inline-flex items-center gap-2"
        data-testid="transformations-cta"
      >
        <Sparkles className="w-4 h-4" />
        I want my glow-up · $27
        <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  </section>
);

// ----- REVERSE PSYCH -----
const ReversePsych = () => (
  <section className="relative py-24 md:py-32 section-lemon" data-testid="reverse-section">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <div className="text-center mb-14">
        <span className="tag-pill mb-5">read this before you buy</span>
        <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
          This is{" "}
          <span className="italic text-[var(--coral)]">not</span> for everyone.
          <br />
          honestly.
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
        <div className="sticker-card p-7 -rotate-1" data-testid="not-for-you">
          <h3 className="font-display text-3xl mb-5 text-[var(--ink)]/60">
            Don&apos;t buy this if…
          </h3>
          <ul className="space-y-4 text-[var(--ink)]/70">
            {[
              "You&apos;re fine being invisible online for another year.",
              "You think iPhone selfies do you justice.",
              "You&apos;d rather complain about &apos;the algo&apos; than show up.",
              "Premium clients aren&apos;t something you actually want.",
            ].map((t, i) => (
              <li key={i} className="flex gap-3 text-base font-medium">
                <X className="w-5 h-5 text-[var(--ink)]/40 flex-shrink-0 mt-0.5" />
                <span dangerouslySetInnerHTML={{ __html: t }} />
              </li>
            ))}
          </ul>
        </div>

        <div
          className="sticker-card p-7 rotate-1 text-white shadow-[8px_8px_0_var(--ink)]"
          style={{ background: "var(--burgundy)" }}
          data-testid="for-you"
        >
          <h3 className="font-display text-3xl mb-5">
            This <span className="italic">IS</span> for you if…
          </h3>
          <ul className="space-y-4">
            {[
              { i: Heart, t: "You&apos;re a coach, creator or realtor ready to be SEEN." },
              { i: Zap, t: "You want a feed that books clients while you sleep." },
              { i: TrendingUp, t: "You&apos;re tired of &apos;good enough&apos; content holding you back." },
              { i: Sparkles, t: "How you show up = what you charge. You know it." },
            ].map(({ i: I, t }, k) => (
              <li key={k} className="flex gap-3 text-base font-medium">
                <I className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span dangerouslySetInnerHTML={{ __html: t }} />
              </li>
            ))}
          </ul>
        </div>
      </div>

      <p className="text-center font-display text-3xl md:text-4xl mt-14">
        If you&apos;re still reading — you already know.
      </p>
    </div>
  </section>
);

// ----- FOUNDER -----
const Founder = () => (
  <section
    className="relative py-24 md:py-32 section-cream overflow-hidden"
    data-testid="founder-section"
  >
    <div className="blob bg-[var(--hot-pink)] w-[500px] h-[500px] top-10 -right-40" />

    <div className="relative max-w-6xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <div className="lg:col-span-5 relative order-1">
        <div className="relative">
          <div className="absolute -inset-3 bg-[var(--burgundy)] rounded-[36px] -rotate-2" />
          <div className="relative bg-white border-2 border-[var(--ink)] rounded-[32px] p-3 shadow-[8px_8px_0_var(--ink)] rotate-1">
            <img
              src={FOUNDER_IMG}
              alt="Daniella — CEO &amp; Founder of AI for Boss Babes"
              className="w-full aspect-square object-cover rounded-2xl border-2 border-[var(--ink)]"
              data-testid="founder-image"
            />
          </div>
          <div className="absolute -top-4 -left-4 bg-[var(--lemon)] border-2 border-[var(--ink)] rounded-2xl px-4 py-2 wiggle shadow-[4px_4px_0_var(--ink)]">
            <div className="text-[10px] tracking-[0.25em] uppercase font-bold">
              ceo &amp; founder
            </div>
          </div>
        </div>
      </div>

      <div className="lg:col-span-7 order-2">
        <span className="tag-pill mb-5">who&apos;s behind this</span>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1] mb-3">
          Hey, I&apos;m{" "}
          <span className="font-script text-5xl md:text-6xl lg:text-7xl text-[var(--burgundy)]">
            Daniella
          </span>
        </h2>
        <p className="text-sm md:text-base uppercase tracking-[0.18em] font-bold text-[var(--burgundy)] mb-8">
          CEO &amp; Founder · AI for Boss Babes
        </p>

        <div className="space-y-5 text-[var(--ink)]/80 text-lg leading-relaxed">
          <p>
            I watched too many brilliant women undercharge, underpost, and
            shrink online — waiting for the <i>perfect</i> photoshoot, the{" "}
            <i>right</i> lighting, the <i>someday</i> they could afford to hire
            a team.
          </p>
          <p>
            <b>Someday doesn&apos;t book clients.</b> A feed that looks like you
            mean business does.
          </p>
          <p>
            So I built the thing I wished existed when I started — a studio in
            your phone that gives you 4 magazine-grade photos + 1 scroll-stopping reel
            for <b className="text-[var(--burgundy)]">$27</b>. Not $2,000. Not
            &ldquo;let me get back to you.&rdquo; Just: boom — here&apos;s your
            brand.
          </p>
          <p className="font-display text-2xl md:text-3xl text-[var(--ink)] pt-2">
            You don&apos;t need more time.
            <br />
            You need to finally{" "}
            <span className="italic text-[var(--burgundy)]">show up.</span>
          </p>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <a
            href={CHECKOUT_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackCheckout}
            data-testid="founder-cta"
            className="btn-coral"
          >
            <Sparkles className="w-4 h-4" />
            Let&apos;s do this · $27
            <ArrowRight className="w-4 h-4" />
          </a>
          <span className="font-script text-3xl text-[var(--burgundy)]">
            — xo, Daniella
          </span>
        </div>
      </div>
    </div>
  </section>
);

// ----- CLASSES TEASER (routes to /classes page) -----
// Positioned as the "skeptic catcher" — for visitors not ready to buy the $27 studio.
const ClassesTeaser = () => (
  <section
    id="classes"
    data-testid="classes-teaser-section"
    className="relative py-24 md:py-32 section-ink overflow-hidden border-y-2 border-[var(--ink)]"
  >
    {/* Bright pop accents to make this section unmissable */}
    <div className="blob bg-[var(--coral)] w-[420px] h-[420px] -top-20 -left-20 opacity-70" />
    <div className="blob bg-[var(--lemon)] w-[340px] h-[340px] -bottom-16 -right-10 opacity-50" />

    <div className="relative max-w-3xl mx-auto px-5 md:px-8 text-center">
      <span
        className="inline-flex items-center gap-2 bg-[var(--lemon)] border-2 border-white text-[var(--ink)] text-[10px] tracking-[0.28em] uppercase font-bold px-4 py-2 rounded-full mb-6 shadow-[3px_3px_0_var(--coral)]"
        data-testid="classes-teaser-badge"
      >
        <Sparkles className="w-3.5 h-3.5" />
        not ready for the studio?
      </span>

      <h2 className="font-display text-5xl md:text-7xl leading-[0.95] text-white mb-6">
        Rather{" "}
        <span className="italic text-[var(--lemon)]">
          do it yourself?
        </span>
      </h2>
      <p className="text-white/80 text-lg md:text-xl max-w-xl mx-auto mb-10">
        Learn the exact social media systems that grew these accounts. Bite-sized classes.
        Watch it, apply it, post it — the same day.
      </p>

      <Link
        to="/classes"
        data-testid="see-all-classes-cta"
        className="inline-flex items-center gap-3 bg-[var(--lemon)] hover:bg-white text-[var(--ink)] font-bold text-lg md:text-xl px-8 md:px-12 py-5 md:py-6 rounded-full border-2 border-[var(--ink)] shadow-[8px_8px_0_var(--coral)] hover:shadow-[10px_10px_0_var(--coral)] hover:-translate-y-1 transition-all"
      >
        <Sparkles className="w-5 h-5" />
        See the classes
        <ArrowRight className="w-5 h-5" />
      </Link>

      <p className="mt-6 text-white/50 text-sm font-medium">
        From <b className="text-white">$9</b> · new drops every month
      </p>
    </div>
  </section>
);

// ----- FAQ -----
const faqs = [
  { q: "How fast do I get my photos & reel?", a: "The moment you pay, you&apos;re inside your studio. Upload a selfie and your photos + reel generate in minutes — no waiting, no queue." },
  { q: "Will the photos actually look like me?", a: "Uncannily so. Most clients can&apos;t tell the AI shots from real ones." },
  { q: "Can I use these commercially?", a: "Full commercial rights. Use them on ads, websites, listings, courses — anywhere." },
  { q: "What if I don&apos;t love my photos?", a: "We work with every babe to make sure your studio experience feels worth it. Because it&apos;s a digital product with unlimited generations, refunds aren&apos;t automatic &mdash; but reach out and we&apos;ll take care of you." },
  { q: "Why is it only $27?", a: "It&apos;s a founding offer — we&apos;re onboarding our first wave of clients at beta pricing while we gather receipts. Once this round fills, pricing returns to $47. Founders get locked in." },
];

const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 section-peach">
    <div className="max-w-3xl mx-auto px-5 md:px-8">
      <div className="text-center mb-12">
        <span className="tag-pill mb-5">questions?</span>
        <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
          The objections you&apos;re
          <br />
          <span className="italic text-[var(--coral)]">already typing.</span>
        </h2>
      </div>

      <Accordion type="single" collapsible className="w-full space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="bg-white border-2 border-[var(--ink)] rounded-2xl px-5 shadow-[4px_4px_0_var(--ink)]"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="font-display text-xl md:text-2xl py-5 text-left hover:no-underline hover:text-[var(--coral)]">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[var(--ink)]/75 text-base pb-5 leading-relaxed">
              <span dangerouslySetInnerHTML={{ __html: f.a }} />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

// ----- FINAL CTA -----
const FinalCTA = () => {
  const { h, m, s } = useCountdown(11 * 3600 + 47 * 60);
  return (
    <section
      data-testid="final-cta"
      className="relative py-28 md:py-36 section-ink overflow-hidden"
    >
      <div className="blob bg-[var(--coral)] w-[600px] h-[600px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-40" />

      <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
        <span className="tag-pill mb-6 bg-[var(--lemon)] text-[var(--ink)]">last call</span>
        <h1 className="font-display text-6xl md:text-8xl text-white mb-6 leading-[0.92]">
          One click =
          <br />
          <span className="text-[var(--lemon)] italic">a brand new feed.</span>
        </h1>
        <p className="text-white/70 text-lg max-w-xl mx-auto mb-10">
          This founder pricing won&apos;t last — once this round closes, the price moves to its regular tier.
        </p>

        <div className="inline-flex gap-2 mb-10 bg-white/10 border border-white/20 rounded-2xl p-4 backdrop-blur">
          {[
            ["HRS", h],
            ["MIN", m],
            ["SEC", s],
          ].map(([label, value], i) => (
            <React.Fragment key={label}>
              <div className="flex flex-col items-center min-w-[64px]">
                <span className="font-display text-4xl md:text-5xl text-white tabular-nums">
                  {value}
                </span>
                <span className="text-[10px] tracking-[0.3em] text-white/60 mt-1">
                  {label}
                </span>
              </div>
              {i < 2 && <span className="text-[var(--coral)] text-3xl self-center">:</span>}
            </React.Fragment>
          ))}
        </div>

        <div className="flex justify-center">
          <PillCTA testid="final-cta-button" label="Take my $27 · stand out" />
        </div>

        <div className="mt-10 flex items-center justify-center gap-x-6 gap-y-2 text-white/60 text-xs flex-wrap font-semibold">
          <div className="flex items-center gap-1.5">
            <ShieldCheck className="w-4 h-4 text-[var(--lemon)]" /> all sales final
          </div>
          <div className="flex items-center gap-1.5">
            <Clock className="w-4 h-4 text-[var(--lemon)]" /> ready in minutes
          </div>
          <div className="flex items-center gap-1.5">
            <Zap className="w-4 h-4 text-[var(--lemon)]" /> instant access
          </div>
        </div>
      </div>
    </section>
  );
};

// ----- DISCLAIMER -----
const Disclaimer = () => (
  <section
    className="relative py-14 md:py-16 section-cream border-t-2 border-[var(--ink)]/10"
    data-testid="disclaimer-section"
  >
    <div className="max-w-4xl mx-auto px-5 md:px-8">
      <div className="bg-white border-2 border-[var(--ink)] rounded-2xl p-6 md:p-8 shadow-[4px_4px_0_var(--ink)]">
        <div className="flex items-center gap-2 mb-4">
          <ShieldCheck className="w-4 h-4 text-[var(--burgundy)]" />
          <span className="text-[10px] tracking-[0.28em] uppercase font-bold text-[var(--burgundy)]">
            Disclaimer &amp; Purchase Agreement
          </span>
        </div>
        <p className="text-[var(--ink)]/75 text-sm leading-relaxed mb-5">
          By completing your purchase, you agree to the following terms:
        </p>
        <ul className="space-y-4 text-[var(--ink)]/80 text-sm leading-relaxed">
          <li>
            <b className="text-[var(--ink)]">No Refunds:</b> All sales are final.
            Due to the custom digital nature of this service, no refunds will be
            issued once your order has been placed.
          </li>
          <li>
            <b className="text-[var(--ink)]">Image Rights &amp; Consent:</b> By
            submitting your photo, you confirm you have the right to use the image
            provided and grant <i>AI for Boss Babes</i> permission to use it solely
            for the purpose of creating your studio-quality content.
          </li>
          <li>
            <b className="text-[var(--ink)]">No Revisions:</b> This offer does not
            include revisions. The deliverables provided are final.
          </li>
          <li>
            <b className="text-[var(--ink)]">No Guarantee of Likeness:</b>{" "}
            <i>AI for Boss Babes</i> does not guarantee that the AI-generated images
            will be an exact likeness of you. However, we are committed to working
            with you to deliver a result you are happy with.
          </li>
        </ul>
        <p className="mt-6 text-[var(--ink)]/55 text-xs leading-relaxed">
          See our{" "}
          <a
            href="https://app.gohighlevel.com/v2/preview/RQU58w8y5Mv8wKnG9WI5"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-[var(--burgundy)] font-semibold"
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            href="https://app.gohighlevel.com/v2/preview/h4GD0oF4FX602nHTiCtw?notrack=true"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-[var(--burgundy)] font-semibold"
          >
            Privacy Policy
          </a>{" "}
          for full details. Questions?{" "}
          <a
            href="mailto:info@aiforbossbabes.com"
            className="underline text-[var(--burgundy)] font-semibold"
          >
            info@aiforbossbabes.com
          </a>
        </p>
      </div>
    </div>
  </section>
);

// ----- FOOTER -----
const Footer = () => (
  <footer className="border-t-2 border-[var(--ink)] py-8 section-cream" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 flex flex-col md:flex-row items-center justify-between gap-3 text-[var(--ink)]/70 text-sm">
      <div className="flex items-center gap-2">
        <Sparkles className="w-4 h-4 text-[var(--burgundy)]" />
        <span className="font-display text-lg text-[var(--ink)]">
          <span className="font-script text-2xl text-[var(--burgundy)] mr-1">ai</span>
          for boss babes
        </span>
        <span className="ml-2">© {new Date().getFullYear()}</span>
      </div>
      <div className="flex gap-5 font-semibold items-center">
        <a
          href="https://www.instagram.com/aiforbossbabes/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="hover:text-[var(--coral)] inline-flex items-center gap-1.5"
          data-testid="footer-instagram"
        >
          <Instagram className="w-4 h-4" />
          @aiforbossbabes
        </a>
        <a
          href="https://app.gohighlevel.com/v2/preview/h4GD0oF4FX602nHTiCtw?notrack=true"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-[var(--coral)]"
          data-testid="footer-privacy"
        >
          Privacy
        </a>
        <a
          href="https://app.gohighlevel.com/v2/preview/RQU58w8y5Mv8wKnG9WI5"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-[var(--coral)]"
          data-testid="footer-terms"
        >
          Terms
        </a>
        <a
          href="mailto:info@aiforbossbabes.com"
          className="hover:text-[var(--coral)]"
          data-testid="footer-contact"
        >
          Contact
        </a>
      </div>
    </div>
  </footer>
);

// ----- STICKY MOBILE CTA -----
const StickyMobileCTA = () => (
  <div
    data-testid="mobile-sticky-cta"
    className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-[var(--ink)] border-t-2 border-[var(--coral)] px-4 py-3 flex items-center justify-between gap-3"
  >
    <div>
      <div className="text-[10px] uppercase tracking-widest text-[var(--lemon)] font-bold">
        founding offer
      </div>
      <div className="text-white text-sm font-bold">
        <span className="font-script text-xl text-[var(--burgundy)] mr-1">ai</span>for boss babes{" "}
        · <span className="line-through text-white/40 text-xs mr-1">$47</span>
        <span className="text-[var(--lemon)]">$27</span>
      </div>
    </div>
    <a
      href={CHECKOUT_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={trackCheckout}
      className="btn-coral !py-2.5 !px-5 text-sm"
      data-testid="mobile-cta-button"
    >
      Get it
      <ArrowRight className="w-4 h-4" />
    </a>
  </div>
);

// ----- BRAND BAND -----
const BrandBand = () => (
  <section
    data-testid="brand-band"
    className="w-full border-y-2 border-[var(--ink)] overflow-hidden bg-[#c79a9b]"
  >
    <img
      src={BANNER_URL}
      alt="AI for Boss Babes — empowering every boss woman with AI"
      className="w-full h-[180px] md:h-[240px] object-cover"
      style={{ objectPosition: "center 40%" }}
    />
  </section>
);

// ----- MAIN -----
export default function LandingPage() {
  // Force-mute every video on the page — but skip those marked data-allow-sound
  useEffect(() => {
    const silenceAllVideos = () => {
      document.querySelectorAll("video").forEach((v) => {
        if (v.dataset.allowSound === "true") return;
        v.muted = true;
        v.volume = 0;
        v.defaultMuted = true;
        v.removeAttribute("controls");
      });
    };
    silenceAllVideos();
    const obs = new MutationObserver(silenceAllVideos);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);

  return (
    <div className="relative min-h-screen font-body bg-[var(--cream)]">
      <Header />
      <main className="pb-20 md:pb-0">
        <Hero />
        <PainPoint />
        <Solution />
        <Offer />
        <Gallery />
        <Receipts />
        <ClientWins />
        <Transformations />
        <ReversePsych />
        <Founder />
        <ClassesTeaser />
        <FAQ />
        <FinalCTA />
      </main>
      <Disclaimer />
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
